export const MAINTENANCE_PAGE = {
  TITLE: 'Maintenance in progress',
  MESSAGE: "We're performing scheduled maintenance and will be back shortly.",
  THANKS: 'Thank you for your patience.',
  STATUS: 'Maintenance',
}
